'use client'

import React from 'react'
import { Box } from '@mui/material'
import LanguageToggleWrapper from '../../../languageToggle'
import { HeaderLogo } from '../../shared/HeaderLogo'
import { SignInButton } from '../../shared/SignInButton'
import { UserMenu } from '../../shared/UserMenu'

interface MobileHeaderProps {
    user: { signedIn: boolean; email?: string; displayName?: string }
    menuAnchor: HTMLElement | null
    onMenuOpen: (event: React.MouseEvent<HTMLElement>) => void
    onMenuClose: () => void
    onModalOpen: () => void
    onSignOut: () => void
    t: (key: string) => string
    disableUserMenu?: boolean
    locale: string
    isRTL: boolean
    direction: 'ltr' | 'rtl'
    domainCountry?: string
}

const MobileHeader: React.FC<MobileHeaderProps> = ({
    user,
    menuAnchor,
    onMenuOpen,
    onMenuClose,
    onModalOpen,
    onSignOut,
    t,
    disableUserMenu = false,
    locale,
    isRTL,
    direction,
    domainCountry
}) => {

    return (
        <>
            <Box
                sx={{
                    width: '100%',
                    bgcolor: 'background.paper',
                    borderBottom: '1px solid',
                    borderColor: 'grey.200',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    px: 2,
                    py: 2,
                    height: 54,
                    direction: direction
                }}
            >
                {/* Left: Logo */}
                <HeaderLogo variant="mobile" locale={locale} domainCountry={domainCountry} />

                {/* Right: Language Toggle + Sign In / User Menu */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5
                    }}
                >
                    <LanguageToggleWrapper />
                    {user.signedIn ? (
                        <></>
                    ) : (
                        <SignInButton onClick={onModalOpen} t={t} variant="mobile" />
                    )}
                </Box>
            </Box>

            <UserMenu
                open={!!menuAnchor && user.signedIn}
                anchorEl={menuAnchor}
                menuItems={[]}
                onClose={onMenuClose}
                onSignOut={onSignOut}
                t={t}
                variant="mobile"
                isRTL={isRTL}
            />
        </>
    )
}

export { MobileHeader }
export type { MobileHeaderProps }
